import { AppNavItem } from '../types/nav.types';
import { ApiIcon, DownloadIcon, PricingIcon, SupportIcon, UserIcon } from '../components/ob-icons';

export const MAIN_NAV_ITEMS: AppNavItem[] = [
  { path: '/pricing', label: 'Pricing', icon: PricingIcon },
  { path: '/api', label: 'API', icon: ApiIcon, requiresAuth: true },
];

export const ACCOUNT_NAV_ITEMS: AppNavItem[] = [
  { path: '/settings', label: 'Settings', icon: UserIcon, requiresAuth: true },
  { path: '/support', label: 'Support', icon: SupportIcon },
  { path: 'https://1browser.com/download/', label: 'Download', icon: DownloadIcon, isExternal: true },
];
